<template>

  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false"
          :show-top-header="true" buy-button-class="btn-default btn-small">

        <div class="rn-blog-area rn-section-gap">
            <div class="container">
              <div class="row">
                <div class="col-lg-12">
                  <SectionTitle
                      text-align="center"
                      subtitle="YAO XIE GONG MAO"
                      title="动态资讯"
                      description=""
                      data-aos="fade-up"
                  />
                </div>
              </div>
                <div class="row mt_dec--30">
                    <div class="col-lg-12">
                        <div class="row row--15">
                            <div class="col-lg-6 mt--30"
                                 data-aos="slide-up"
                                 data-aos-duration="800"
                                 :data-aos-delay="100 + index"
                                 v-for="(blog, index) in newsData"
                                 :key="index">
                                <HomeNewsListDetail :blog="blog" blog-post-style="list"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12 text-center">
                      <Pagination
                          @change="changePage"
                          :current="queryParams.pageNum"
                          :pageSize="queryParams.pageSize"
                          :total="total"
                          :hideOnSinglePage="true"
                          :showQuickJumper="true"
                          :showTotal="true"
                          placement="center"
                      />
                    </div>
                </div>
            </div>
        </div>
  </Layout>
</template>

<script>
    import Icon from '../../components/icon/Icon'
    import HomeNewsListDetail from '../home-site/HomeNewsListDetail'
    import Layout from '../../components/common/Layout'
    import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
    //import BlogPostMixin from '../../mixins/BlogPostMixin'
    import Pagination from "../../components/elements/page/Pagination";

    export default {
        name: 'HomeNewsList',
        components: {Icon, HomeNewsListDetail, Layout, SectionTitle,Pagination},
        //mixins: [BlogPostMixin],
        data(){
          return{
            queryParams: {
              pageNum: 1,
              pageSize: 8,
            },
            total: 0,
            newsData:[],
          }
        },
        created() {
          this.getNews(this.queryParams);
        },
        methods:{
          getNews(data){
            this.getRequest("/system/web/listNews",data).then(resp=>{

              let newsData = resp.data.rows;
              newsData.forEach(item => {
                if (item.thumbUrl) {
                  let fileUrl = item.thumbUrl;
                  fileUrl = process.env.VUE_APP_BASE_API + fileUrl;
                  item.thumbUrl = fileUrl;
                } else {
                  item.thumbUrl = "";
                }
              })
              this.newsData = newsData;

              this.total = resp.data.total;
            })
          },
          changePage(pager){
            this.queryParams.pageNum = pager.page;
            this.queryParams.pageSize = pager.pageSize;
            this.getNews(this.queryParams);
          }
        }
    }
</script>